import request from './request'

const menu = {
    postLogin(params) {
        return request({
            method: 'POST',
            url: '/login-center/store/pc/login',
            data: params
        })
    },
    logout(params) {
        return request({
            method: 'POST',
            url: '/login-center/store/pc/logout',
            data: params
        })
    },
    //验机报告
    getInspectionReport(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/getInspectionReport',
            params
        })
    },
    // 收款人明细
    detailgetOrderPayee(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/getOrderPayee',
            data: params
        })
    },

    // 获取验证码
    sendCode(params) {
        return request({
            method: 'GET',
            url: '/store/pc/center/sendCode',
            params: params
        })
    },
    // 重置密码
    resetPwd(params) {
        return request({
            method: 'POST',
            url: '/store/pc/center/resetPwd',
            data: params,
        })
    },
    //首页
    //首页订单列表
    HomeOrderList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStatisticsRank',
            data: params,
        })
    },
    excelStatisticsRank(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelStatisticsRank',
            data: params,
            responseType: 'blob'
        })
    },
    // //首页数据
    HomeData(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/dataStatistics',
            data: params,
        })
    },
    // //首页图表
    echartsListOrder(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStatisticsOrderAmount',
            data: params,
        })
    },

    // //累计数量弹窗列表
    // getOrderDeal(params) {
    //     return request({
    //         method: 'POST',
    //         url: '/store/pc/statistics/orderDeal',
    //         data: params,
    //     })
    // },
    getOrderDeal(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStaffRankInStore',
            data: params
        })
    },
    statisticsorderDeal(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/orderDeal',
            data: params
        })
    },
    // //首页图表
    echartsListDeal(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStatisticsOrder',
            data: params,
        })
    },
    rankStatistics(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/rankStatistics',
            data: params,
        })
    },
    // 利润排行榜下沉
    rankStatisticsDown(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/rankStatisticsDown',
            data: params
        })
    },
    // 店员询价数据统计
    getStaffInquiryStatistics(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStaffInquiryStatistics',
            data: params
        })
    },

    // 导出店员询价数据统计
    getStaffInquiryExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStaffInquiryExcel',
            data: params,
            responseType: 'blob'
        })
    },
    // 各门店交易数据统计
    getStoreStatisticsRank(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStoreStatisticsRank',
            data: params
        })
    },
    // 导出各门店交易数据统计
    getexcelStoreStatisticsRank(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelStoreStatisticsRank',
            data: params,
            responseType: 'blob'
        })
    },
    // 门店新机指标分析
    excelStoreNewMachineAnalysis(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelStoreNewMachineAnalysis',
            data: params,
            responseType: 'blob'
        })
    },
    // 各回收商交易数据统计
    getMerchantStatisticsRank(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getMerchantStatisticsRank',
            data: params
        })
    },
    // 导出各回收商交易数据统计
    getexcelMerchantStatisticsRank(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelMerchantStatisticsRank',
            data: params,
            responseType: 'blob'
        })
    },
    // 换新补贴数据-按门店统计
    getStoreNewTable(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewStore',
            data: params,
        })
    },
    // 换购录音统计-按店员统计
    getRenewSoundStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewSoundStaff',
            data: params,
        })
    },
    //导出换购录音统计数据(按门店统计)
    getRenewSoundStoreExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewSoundStoreExcel',
            data: params,
            responseType: 'blob'
        })
    },
    //导出换新补贴数据(按门店统计)
    getRenewStoreExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewStoreExcel',
            data: params,
            responseType: 'blob'
        })
    },
    //换新补贴数据-按员工统计
    getRenewStaffExCEL(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewStaffExcel',
            data: params,
            responseType: 'blob'
        })
    },
      //隐藏ID-获取订单信息
      hideIdgetOrderInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/hideid/getOrderInfo',
            params,
        })
    },
    // //换新补贴数据-按换新商品统计
    // getRenewProductExCEL(params) {
    //     return request({
    //         method: 'POST',
    //         url: '/store/pc/statistics/getRenewProduct',
    //         data: params,
    //         responseType: 'blob'
    //     })
    // },
    //导出换购录音统计数据(按店员统计)
    getRenewSoundStaffExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewSoundStaffExcel',
            data: params,
            responseType: 'blob'
        })
    },
    // 换购录音统计-按门店统计
    getRenewSoundStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewSoundStore',
            data: params,
        })
    },
    // 换新补贴数据-按员工统计
    getStaffNewTable(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewStaff',
            data: params,
        })
    },
    // 换新补贴数据-按换新商品统计
    getShopNewTable(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getRenewProduct',
            data: params,
        })
    },
    ///首页获取已合作的回收商下拉列表（不含取消合作）
    getMiddleAdoptMerchant(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/merchant/getMiddleAdoptMerchant',
            params: params,
        })
    },
    // 首页门店下拉
    getStoreSelectOrder(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getStoreSelectOrder',
            params: params,
        })
    },
    // 首页门店下拉
    getStoreSelectUnEnable(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getStoreSelectUnEnable',
            params: params,
        })
    },
    // 门店下拉列表【调拨】
    getStoreSelectAllot(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getStoreSelectAllot',
            params: params,
        })
    },
    //回收商家报价分析
    getMerchantRankInStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getMerchantRankInStore',
            data: params,
        })
    },
    //回收商家报价振幅
    getMerchantAmplitude(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getMerchantAmplitude',
            data: params,
        })
    },
    //批量-靓机自收额度设置
    saveBachSelfBuyNiceConfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/store/saveBachSelfBuyNiceConfig',
            data: params,
        })
    },
    //更新是否启用门店自收靓机开关
    updateIsOpenSelfBuyNiceMachine(params) {
        return request({
            method: 'GET',
            url: '/store/pc/store/updateIsOpenSelfBuyNiceMachine',
            params: params,
        })
    },
    //回收商家报价振幅订单
    getMerchantAmplitudeOrder(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getMerchantAmplitudeOrder',
            data: params,
        })
    },
    //店员交易数据弹窗列表
    getStaffRankInStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getStaffRankInStore',
            data: params,
        })
    },
    //回收商家报价基础数据分析导出
    getMerchantRankInStoreExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/getMerchantRankInStoreExcel',
            data: params,
            responseType: 'blob'
        })
    },
    // 门店职员列表下拉
    getStaffList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/store/getStaffList',
            data: params,
        })
    },
    ///////////////////////////////////////////系统管理
    //角色列表
    RoleList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/role/list',
            data: params,
        })
    },
    //角色详情
    RoleInfoRes(params) {
        return request({
            method: 'GET',
            url: '/store/pc/role/info',
            params: params,
        })
    },
    //角色编辑
    RoleEdit(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/role/edit',
            data: params,
        })
    },
    //角色添加
    roleAdd(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/role/add',
            data: params,
        })
    },
    // 角色菜单
    getMenuList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/role/menu',
            params: params,
        })
    },
    //职员列表
    getWorkerList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/staffList',
            data: params,
        })
    },
    //获取账户信息
    getStaffAccount(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/getStaffAccount',
            params: params,
        })
    },
    //获取账户信息
    manageStaffSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/manageStaffSelect',
            params: params,
        })
    },
    //生成职员账号
    createPcAcc(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/createPcAcc',
            params: params,
        })
    },
    //角色下拉列表
    roleSelectByRole(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/roleSelectByRole',
            params: params,
        })
    },
    //通过角色查询不同的小程序用户下拉
    getXcxStaffSelectByRole(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/getXcxStaffSelectByRole',
            params: params,
        })
    },
    //保存后台账号
    savePcStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/savePcStaff',
            data: params,
        })
    },
    //保保存小程序账号
    saveXcxStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/saveXcxStaff',
            data: params,
        })
    },
    //重置密码
    resetStaffPwd(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/resetStaffPwd',
            params: params,
        })
    },
    //删除角色
    removeStaff(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/removeStaff',
            params: params,
        })
    },
    //离职
    updateIsQuit(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/updateIsQuit',
            params: params,
        })
    },
    //是否启用
    updateWorkerIsEnable(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/updateIsEnable',
            params: params,
        })
    },
    // 导入职员
    importXcxStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/inputXcxStaff',
            data: params,
        })
    },
       //查询该商家是线上支付还是线下支付
       getPayMode(params) {
        return request({
            method: 'POST',
            url: '/store/pc/config/getPayMode',
            data: params,
        })
    },
    // 调拨店员
    allot(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/allot',
            data: params,
        })
    },
    // 调拨店员(待处理订单数)
    allotNoTodoOrderNum(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/allotNoTodoOrderNum',
            data: params,
        })
    },
    // 调拨店员(待处理订单列表)
    allotNoTodoOrderList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/allotNoTodoOrderList',
            data: params,
        })
    },
    // 导出小程序账号
    exportXcxStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/exportXcxStaff',
            data: params,
            responseType: 'blob'
        })
    },
    ///////////////////////////////////////////回收订单
    orderList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/list',
            data: params,
        })
    },
    // 订单状态下拉
    orderStateList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/order/orderStateList',
            params: params,
        })
    },
    // 订单导出
    orderExcel(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/excel',
            data: params,
            responseType: 'blob'
        })
    },

    exportExcel(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/exportExcel',
            data: params,
            responseType: 'blob'
        })
    },
    // 差价订单导出
    excelDepreciate(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/excelDepreciate',
            data: params,
            responseType: 'blob'
        })
    },
    // 订单详情
    orderInfo(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/order/info',
            params: params,
        })
    },
    // 报价回收商
    orderStoreList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/order/listQuoteByOrderNo',
            params: params,
        })
    },
    // 获取动态
    orderFlow(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/order/orderFlow',
            params: params,
        })
    },

    // 差价订单列表
    listByDepreciate(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/listByDepreciate',
            data: params,
        })
    },
    // 差价订单回收商家下拉
    getAllMiddleAdoptMerchant(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/merchant/getAllMiddleAdoptMerchant',
            params: params,
        })
    },
    // 确认差价
    confirmDepreciate(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/confirmDepreciate',
            data: params,
        })
    },
    // 拒绝差价
    rejectDepreciate(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/rejectDepreciate',
            data: params,
        })
    },
    // 撤销订单
    refundOrder(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/order/refundOrder',
            data: params,
        })
    },
    ///////////////////////////////////////////门店管理
    // 门店管理、、、门店列表
    StaffManageList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/store/getStoreList',
            data: params,
        })
    },
    updateIsEnable(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/updateIsEnable',
            params: params,
        })
    },
    // 门店保存
    saveStore(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/store/saveStore',
            data: params,
        })
    },
    // 门店下拉列表
    getStoreSelectList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getStoreSelectList',
            params: params,
        })
    },
    // 门店下拉列表(全部)
    getAllStoreSelectList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getAllStoreSelectList',
            params: params,
        })
    },
    //门店下拉列表(演示机)
    getAllStoreSelectListOnline(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/store/getAllStoreSelectListOnline',
            params: params,
        })
    },
    // 查询报价设置列表
    quoteConfigList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/store/quoteConfigList',
            data: params,
        })
    },
    // 保存报价设置
    saveQuoteConfig(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/store/saveQuoteConfig',
            data: params,
        })
    },
    // 导入门店
    inputStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/store/inputStore',
            data: params,
        })
    },
    // 导出商品列表
    exportGoods(params) {
        return request({
            method: 'POST',
            url: '/store/pc/product/excel',
            data: params,
            responseType: 'blob'
        })
    },
    // 导出门店
    exportStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/store/exportStore',
            data: params,
            responseType: 'blob'
        })
    },

    ///////////////////////////////////////////第三方回收商
    //筛选合作回收商家
    queryUnionList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/merchant/queryUnionList',
            data: params,
        })
    },
    //根据domain获取资源
    getDomainconfig(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/sysDep/static/config/getDomain',
            data: params,
        })
    },
    //优品订单列表
    excellentList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/order/list',
            data: params,
        })
    },
    //保存职员微信号
    saveStaffWechatCode(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/online/store/saveStaffWechatCode',
            data: params,
        })
    },
    // 优品订单详情
    premiumInfo(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/product/order/info',
            params: params,
        })
    },
    // 回收商是否启用报价
    merchantIsEnable(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/merchant/updateIsEnable',
            params: params,
        })
    },
    // 撤销审核
    listOper(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/merchant/listOper',
            data: params,
        })
    },
    // 修改个人资料
    updateOwnInfo(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/center/updateOwnInfo',
            data: params,
        })
    },
    // 商品管理列表
    commodityList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/list',
            data: params,
        })
    },
    // 商品管理列分享记录
    commSharelist(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/shareList',
            data: params,
        })
    },
    // 商品管理列调库
    transferStore(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/transferStore',
            data: params,
        })
    },
    // 商品管理列上下架记录
    optList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/optList',
            data: params,
        })
    },
    // 商品管理列Q-调库记录
    stockList(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/stockList',
            data: params,
        })
    },
    // 商品管理列Q-上架
    soldIn(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/soldIn',
            data: params,
        })
    },
    // 商品管理列Q-下架
    soldOut(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/soldOut',
            data: params,
        })
    },
    // 商品管理列Q-下市
    delisting(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/delisting',
            data: params,
        })
    },
    // 商品管理列Q-质检报告
    delireport(params = {}) {
        return request({
            method: 'POST',
            url: '/store/pc/product/report',
            data: params,
        })
    },
    // 旧机分类列表
    getAllMachineType(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/assembly/getAllMachineType',
            params: params,
        })
    },
    // 旧机品牌-下拉列表
    selectBrandList(params = {}) {
        return request({
            method: 'GET',
            url: '/store/pc/assembly/selectBrandList',
            params: params,
        })
    },
    // Q-机型下拉列表
    listSelected(data) {
        return request({
            method: 'POST',
            url: '/store/pc/assembly/listSelected',
            data,
        })
    },

    listSimpleMerchantView(params) {
        return request({
            method: 'GET',
            url: '/store/pc/merchant/getMiddleAdoptMerchant',
            params: params,
        })
    },
    //获取已合作的回收商（添加门店）下拉列表
    findInquiryMerchantEnable(params) {
        return request({
            method: 'GET',
            url: '/store/pc/merchant/findInquiryMerchantEnable',
            params: params,
        })
    },
    getSerTypeList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/account/detail/getSerTypeList',
            params,
        })
    },
    getAccountPayList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/getList',
            data: params,
        })
    },
    // 调账
    adjustmentAccount(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/adjustmentAccount',
            data: params,
        })
    },
    //导出收款明细
    getOrderPayeeExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/getOrderPayeeExcel',
            data: params,
            responseType: 'blob'
        })
    },
    //获取商家账户信息
    getCompanyAccount(params) {
        return request({
            method: 'GET',
            url: '/store/pc/account/detail/getCompanyAccount',
            params,
        })
    },
    //线下结算平账
    writeOffAccount(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/writeOffAccount',
            data: params,
        })
    },
    // 报价修改信息列表
    getUpdatedQuoteLog(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/getUpdatedQuoteLog',
            params,
        })
    },

    // 能否查询回收数据(仅店长)
    // /store/pc/staff/updateCanSeeRecycleData
    // /store/pc/staff/updateShopownerCanSeeRecycleData
    updateCanSeeRecycleData(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/updateShopownerCanSeeRecycleData',
            params,
        })
    },

    // 是否门店收银员
    updateIsStoreCashier(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/updateIsStoreCashier',
            params,
        })
    },
    // 已绑定从账号
    getSubStaffs(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/subStaffs',
            params,
        })
    },
    // 从账号操作
    operateSubStaff(params) {
        return request({
            method: 'POST',
            url: '/store/pc/staff/operateSubStaff',
            data: params,
        })
    },

    // 红包统计列表
    getCompanyStatistic(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/getCompanyStatistic',
            data: params,
        })
    },

    // 员工统计红包
    getStaffInCompanyStatistic(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/getStaffInCompanyStatistic',
            data: params,
        })
    },

    // 红包明细出账入账接口
    // /store/pc/redpacket/detail
    redpacketdetail(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/detail',
            data: params,
        })
    },

    // 红包明细导出Execl
    // /store/pc/redpacket/detail/excel
    redpacketdetailexcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/detail/excel',
            data: params,
            responseType: 'blob'
        })
    },
    //导出红包统计
    getCompanyStatisticExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/getCompanyStatisticExcel',
            data: params,
            responseType: 'blob'
        })
    },

    //导出Excel-红包账单明细
    detailExcelAll(params) {
        return request({
            method: 'POST',
            url: '/store/pc/redpacket/detail/excelAll',
            data: params,
            responseType: 'blob'
        })
    },

    // 红包明细子选项接口
    // /store/pc/redpacket/getSerTypeList
    redpacketgetSerTypeList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/redpacket/getSerTypeList',
            params,
        })
    },

    // 查询区域列表
    // /store/pc/area/list
    arealist(params) {
        return request({
            method: 'POST',
            url: '/store/pc/area/list',
            data: params
        })
    },

    // 保存区域
    // /store/pc/area/save
    areasave(params) {
        return request({
            method: 'POST',
            url: '/store/pc/area/save',
            data: params
        })
    },

    // 未配置总监列表
    // /store/pc/area/inspectorAreaSelect
    getNotPInspectorSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/area/inspectorAreaSelect',
            params,
        })
    },

    // 删除区域
    // /store/pc/area/removeById
    arearemoveById(params) {
        return request({
            method: 'GET',
            url: '/store/pc/area/removeById',
            params,
        })
    },

    // 区域下拉列表
    // /store/pc/area/getAreaSelect
    areagetAreaSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/area/getAreaSelect',
            params,
        })
    },

    // 加价详情
    // /store/pc/order/addPriceInfo
    orderaddPriceInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/addPriceInfo',
            params: params
        })
    },
    // 内部加价详情
    insideApplyInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/insideApplyInfo',
            params: params
        })
    },

    // 获取个性化配置
    // /store/pc/config/getCompanyCustomConfig
    getCompanyCustomConfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/config/getCompanyCustomConfig',
            data: params
        })
    },
    // 是否店长入库
    setSmInStock(params) {
        return request({
            method: 'POST',
            url: '/store/pc/product/setSmInStock',
            data: params
        })
    },

    // 设置个性化配置
    setCompanyCustomConfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/config/setCompanyCustomConfig',
            data: params
        })
    },

    // 门店补拍统计列表
    // /store/pc/again/photo/getCensus
    photogetCensus(params) {
        return request({
            method: 'POST',
            url: '/store/pc/again/photo/getCensus',
            data: params,
        })
    },

    // 门店员工补拍数据统计
    // /store/pc/again/photo/getStoreStaffCensus
    getStoreStaffCensus(params) {
        return request({
            method: 'POST',
            url: '/store/pc/again/photo/getStoreStaffCensus',
            data: params,
        })
    },

    // 店员待补拍数据
    // /store/pc/again/photo/getStaffWaitOrder
    getStaffWaitOrder(params) {
        return request({
            method: 'POST',
            url: '/store/pc/again/photo/getStaffWaitOrder',
            data: params,
        })
    },

    // 订单申请补拍记录
    // /store/pc/again/photo/getOrderApplyByOrderNo
    getOrderApplyByOrderNo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/again/photo/getOrderApplyByOrderNo',
            params: params
        })
    },


    // 店员待主动补拍订单
    // /store/pc/again/photo/getStaffInitiativeOrder
    getStaffInitiativeOrder(params) {
        return request({
            method: 'POST',
            url: '/store/pc/again/photo/getStaffInitiativeOrder',
            data: params,
        })
    },

    getExpressOrders(params) {
        return request({
            method: 'POST',
            url: '/store/pc/express/order/getExpressOrders',
            data: params,
        })
    },


    logisticsInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/express/order/logisticsInfo',
            params: params
        })
    },

    excelexpressorder(params) {
        return request({
            method: 'POST',
            url: '/store/pc/express/order/excel',
            data: params,
            responseType: 'blob'
        })
    },


    // getOrderListByExpressNo
    getOrderListByExpressNo(params) {
        return request({
            method: 'POST',
            url: '/store/pc/order/getOrderListByExpressNo',
            data: params,
        })
    },
    // Q-补拍查询
    listRemakeByOrderNo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/listRemakeByOrderNo',
            params
        })
    },

    //查询标签列表
    getStoreTagList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/tag/list',
            data: params,
        })
    },

    //标签下拉列表
    getStoreTagSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/tag/getStoreTagSelect',
            params: params,
        })
    },

    //保存标签
    saveStoreTag(params) {
        return request({
            method: 'POST',
            url: '/store/pc/tag/save',
            data: params,
        })
    },

    //保存门店与标签的关系
    saveRelation(params) {
        return request({
            method: 'POST',
            url: '/store/pc/tag/saveRelation',
            data: params,
        })
    },

    //删除标签
    removeById(params) {
        return request({
            method: 'GET',
            url: '/store/pc/tag/removeById',
            params: params,
        })
    },
    //标签移除门店
    removeByStore(params) {
        return request({
            method: 'GET',
            url: '/store/pc/tag/removeByStore',
            params: params,
        })
    },
    //获取顾客订单信息
    getCustomerList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/order/getCustomerList',
            data: params,
        })
    },
    //-顾客订单信息导出Excel
    excelCustomer(params) {
        return request({
            method: 'POST',
            url: '/store/pc/order/excelCustomer',
            data: params,
            responseType: 'blob'
        })
    },
    //保存顾客订单备注
    saveCustomerRemark(params) {
        return request({
            method: 'POST',
            url: '/store/pc/order/saveCustomerRemark',
            data: params,
        })
    },
    //撤销收货详情
    findCancelReceiptInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/findCancelReceiptInfo',
            params: params,
        })
    },
    //获取入驻时间戳
    getEntryTime(params) {
        return request({
            method: 'GET',
            url: '/store/pc/month/Statistics/getDate',
            params: params,
        })
    },
    //询价量、成交量环比数据
    getInquiryDeal(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getInquiryDeal',
            data: params,
        })
    },
    //回收交易额、用户成交额&公司毛利环比数据
    getDealFinalProfit(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getDealFinalProfit',
            data: params,
        })
    },
    //回收单价&成交客单价&单机毛利
    getAvgPrice(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getAvgPrice',
            data: params,
        })
    },
    //公司毛利&员工奖励
    getProfitReward(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getProfitReward',
            data: params,
        })
    },
    //毛利率环比数据
    getProfitRate(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getProfitRate',
            data: params,
        })
    },
    //成交率、退款、取消率、换新率...
    getMonthRate(params) {
        return request({
            method: 'POST',
            url: '/store/pc/month/Statistics/getMonthRate',
            data: params,
        })
    },
    //重复询价详情
    orderinfoRepeat(params) {
        return request({
            method: 'GET',
            url: '/platform/pc/order/infoRepeat',
            params,
        })
    },
    //获取红包配置设置
    getPayconfig(params) {
        return request({
            method: 'GET',
            url: '/store/pc/minimall/payconfig/get',
            params,
        })
    },
    //保存红包配置设置
    savePayconfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/minimall/payconfig/save',
            data: params,
        })
    },
    //支付配置详情
    configInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/config/configInfo',
            params,
        })
    },
    // 支付配置详情（线上）
    configInfoNew(params) {
        return request({
            method: 'POST',
            url: '/store/pc/config/configInfoNew',
            data:params,
        })
    },
      // 支付配置详情（线下）
      configInfoOffLineNew(params) {
        return request({
            method: 'POST',
            url: '/store/pc/config/configInfoOffLineNew',
            data:params,
        })
    },
 // Q-报全部机型-指定机型（分页）
 listByTypeBrandPage(params) {
    return request({
        method: 'POST',
        url: '/store/pc/config/listByTypeBrandPage',
        data:params,
    })
},
// Q-品牌下拉
ResidentList(params) {
    return request({
        method: 'GET',
        url: '/store/pc/config/oldBrandSelectList',
        params,
    })
},
// Q-分类下拉
selectList(params) {
    return request({
        method: 'GET',
        url: '/store/pc/config/oldMachineTypeSelectList',
        params,
    })
},
















































































































































    // 问题类型下拉
    templateTypeSelect(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/question/type/select`,
            data: params,
        })
    },
    // 添加问题更新问题
    questionSaveOrUpdate(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/question/saveOrUpdate`,
            data: params,
        })
    },
    questionList(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/question/list`,
            data: params,
        })
    },
    platformQuestion(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/question/platform/question`,
            data: params,
        })
    },
    importQuestion(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/question/import/question`,
            data: params,
        })
    },
    updateSort(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/question/update/sort',
            params: params,
        })
    },
    questionDelete(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/question/delete',
            params: params,
        })
    },
    userExcel(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/user/excel`,
            data: params,
            responseType: 'blob'
        })
    },
    userList(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/user/list`,
            data: params,
        })
    },
    assessHistory(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/user/assess/history`,
            data: params,
        })
    },
    // 本机机型列表
    userMachineList(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/user/userMachineList`,
            data: params,
        })
    },
    pointsRecord(params) {
        return request({
            method: 'POST',
            url: `/store/pc/company/user/points/record`,
            data: params,
        })
    },
    pointsType(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/user/points/type',
            params: params,
        })
    },
    // 回收参数
    parametersGetConfig(params) {
        return request({
            method: 'GET',
            url: '/store/pc/reclaim/parameters/get/config',
            params: params,
        })
    },
    updateConfig(params) {
        return request({
            method: 'GET',
            url: '/store/pc/reclaim/parameters/update/config',
            params: params,
        })
    },
    // 先下订单list
    assessOrderList(params) {
        return request({
            method: 'POST',
            url: `/store/pc/assess/order/list`,
            data: params,
        })
    },
    // 订单详情
    assessOrderInfo(params) {
        return request({
            method: 'GET',
            url: `/store/pc/assess/order/info`,
            params: params,
        })
    },
    assessOrderExcel(params) {
        return request({
            method: 'POST',
            url: `/store/pc/assess/order/excel`,
            data: params,
            responseType: 'blob'
        })
    },
    //赠品管理
    giftList(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/list`,
            data: params,
        })
    },
    //添加赠品或更新赠品
    addOrUpdate(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/addOrUpdate`,
            data: params,
        })
    },
    //赠品发放记录
    issueRecord(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/issue/record`,
            data: params,
        })
    },
    //礼包列表
    getGiftPackPage(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/pack/getGiftPackPage`,
            data: params,
        })
    },
    //礼包启用禁用
    updateEnable(params) {
        return request({
            method: 'GET',
            url: `/store/pc/gift/pack/updateEnable`,
            params,
        })
    },
    //添加礼包或更新礼包
    addPackUpdate(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/pack/addOrUpdate`,
            data: params,
        })
    },
    //删除礼包
    removeGiftPack(params) {
        return request({
            method: 'GET',
            url: `/store/pc/gift/pack/removeGiftPack`,
            params,
        })
    },
    //礼包详情
    packInfo(params) {
        return request({
            method: 'GET',
            url: `/store/pc/gift/pack/info`,
            params,
        })
    },
    //礼包赠品信息
    getGiftList(params) {
        return request({
            method: 'GET',
            url: `/store/pc/gift/pack/getGiftList`,
            params,
        })
    },
    //获取执行门店
    getUseStore(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/pack/getUseStore`,
            data: params,
        })
    },
    //添加执行门店
    saveUseStore(params) {
        return request({
            method: 'POST',
            url: `/store/pc/gift/pack/saveUseStore`,
            data: params,
        })
    },
    // 删除执行门店
    removeUseStore(params) {
        return request({
            method: 'GET',
            url: `/store/pc/gift/pack/removeUseStore`,
            params,
        })
    },
    // -赠品发放列表
    orderGiftInfo(params) {
        return request({
            method: 'GET',
            url: `/store/pc/assess/order/gift/info`,
            params,
        })
    },
    // 查看成交明细
    getQuoteCompute(orderNo) {
        return request.get(`/store/pc/order/getQuoteCompute?orderNo=${orderNo}`)
    },
    getHealthList() {
        return request.get("/store/pc/channelassess/getHealthList")
    },
    // 估价单列表
    chxassessList(data) {
        return request.post("/store/pc/channelassess/list", data);
    },
    // 估价单验机报告
    getReport(channelAssessNo) {
        return request.get(`/store/pc/channelassess/getReport?channelAssessNo=${channelAssessNo}`);
    },
    // 估价单导表
    chxassessExcel(data) {
        return request.post("/store/pc/channelassess/excel", data, {
            responseType: 'blob'
        })
    },
    // 门店差异详情
    aptStoreDetail(data) {
        return request.post(`/store/pc/order/apr/detail`, data)
    },
    // 门店导表
    storeExcel(data) {
        return request.post('/store/pc/order/apr/excel', data, {
            responseType: 'blob'
        })
    },
    // 门店审核超5天
    storeSta(data) {
        return request.post('/store/pc/order/apr/sta', data)
    },
    // 门店审核
    storeList(data) {
        return request.post('/store/pc/order/apr/list', data)
    },
    // 换新活动Q-商品列表
    renewActivityList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/list',
            data: params,
        })
    },
    // 添加活动
    addActivity(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/add',
            data: params,
        })
    },
    // 编辑活动
    editActivity(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/edit',
            data: params,
        })
    },
    // Q-待添加门店列表
    addStoreList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/storeList',
            data: params,
        })
    },
    // 添加活动门店
    addActivityStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/addStore',
            data: params,
        })
    },
    // 删除活动门店
    removeStore(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/removeStore',
            data: params,
        })
    },
    // Q-已添加门店列表
    getAddStoreList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/stores',
            data: params,
        })
    },
    // Q-待添加门店列表 
    paddingAddStoreList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/storeList',
            data: params,
        })
    },
    // Q-已添加商品列表
    addActivityProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/products',
            data: params,
        })
    },
    // Q-待添加商品列表
    paddingAddGoodsList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/productList',
            data: params,
        })
    },
    // 添加活动商品
    addActivityaProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/addProduct',
            data: params,
        })
    },
    // 添加活动赠品
    addActivityagift(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/add-gift',
            data: params,
        })
    },
    // 删除活动商品
    deleteActivityaProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/removeProduct',
            data: params,
        })
    },
    // 删除活动赠品
    deleteActivityaGifts(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/remove-gift',
            data: params,
        })
    },
    // 结束活动
    endActivity(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/end',
            data: params,
        })
    },
    // 开始活动
    startActivity(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/activity/start',
            data: params,
        })
    },
    // 海报列表
    getPosterList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/poster/list',
            data: params,
        })
    },
    // 所属分类下拉列表
    typeSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/renew/product/typeSelect',
            params,
        })
    },
    // 订单录音-评价
    getorderSoundcriticizeRemark(params) {
        return request({
            method: 'POST',
            url: '/store/pc/orderRenew/orderSound/criticizeRemark',
            data: params,
        })
    },
    // 订单录音-详情
    getorderSoundinfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/orderRenew/orderSound/info',
            params,
        })
    },
    // 商品下拉列表
    productSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/renew/product/productSelect',
            params,
        })
    },
    // 活动下拉列表
    activitySelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/renew/activity/activitySelect',
            params,
        })
    },
    // 换新商品管理
    // 换新商品Q-商品列表
    renewProductList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/list',
            data: params,
        })
    },
    // Q-商品修改记录
    modifyRecord(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/modifyRecord',
            data: params,
        })
    },
    // 添加商品
    addProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/add',
            data: params,
        })
    },
    // 编辑商品
    editProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/edit',
            data: params,
        })
    },
    // Q-商品详情
    productDetail(params) {
        return request({
            method: 'GET',
            url: '/store/pc/renew/product/detail',
            params,
        })
    },
    // Q-平台图标
    platformIconSelect(params) {
        return request({
            method: 'GET',
            url: '/store/pc/renew/product/platformIconSelect',
            params,
        })
    },
    // 商品上架
    putawayProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/putaway',
            data: params,
        })
    },
    // 商品下架
    downProduct(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/down',
            data: params,
        })
    },
    // 订单详情
    orderRenewList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/orderRenew/list',
            data: params,
        })
    },
    // 导出换新订单
    excelOrderRenew(params) {
        return request({
            method: 'POST',
            url: '/store/pc/orderRenew/excel',
            data: params,
            responseType: 'blob'
        })
    },
    // 导表-换新商品
    excelOrderRenewproducts(params) {
        return request({
            method: 'POST',
            url: '/store/pc/orderRenew/excel-products',
            data: params,
            responseType: 'blob'
        })
    },
    // 换新订单详情
    findProducts(params) {
        return request({
            method: 'GET',
            url: '/store/pc/orderRenew/findProducts',
            params,
        })
    },
    // 换新订单详情
    findSetActivityWarnValue(params) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/setActivityWarnValue',
            data: params,
        })
    },
    // 换新商品导入
    readOutOrderNo(params) {
        return request({
            method: 'POST',
            url: '/store/pc/renew/product/import',
            data: params,
        })
    },
    //恢复已取消订单
    doCancelRestore(data) {
        return request({
            method: 'POST',
            url: '/store/pc/order/doRestore',
            data,
        })
    },
    // 订单列表-恢复已取消记录
    getCancelRestore(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/getRestore',
            params,
        })
    },
    //【门店PC】获取操作日志
    getLogList(data) {
        return request({
            method: 'POST',
            url: '/store/pc/operatorLog/getLogList',
            data,
        })
    },
    // 【门店PC】获取操作日志-节点下拉列表
    getNodeNameList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/operatorLog/getNodeNameList',
            params,
        })
    },
    // 【导表】获取导表日志-操作人下拉列表
    operatorList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/operatorLog/operatorList',
            params,
        })
    },
    //【导表】获取导表日志
    getExportExcelList(data) {
        return request({
            method: 'POST',
            url: '/store/pc/operatorLog/getExportExcelList',
            data,
        })
    },
    // 【导表】获取导表日志-节点下拉列表
    getExportExcelNodeNameList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/operatorLog/getExportExcelNodeNameList',
            params,
        })
    },
    // 是否需要验证
    needValid(params) {
        return request({
            method: 'GET',
            url: '/login-center/store/pc/need/validGoogleCode',
            params,
        })
    },
    // 生成谷歌动态口令
    createGoogleCode(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/create-google-code',
            params,
        })
    },
    // 查看谷歌动态口令
    queryGoogleCode(params) {
        return request({
            method: 'GET',
            url: '/store/pc/staff/query-google-code',
            params,
        })
    },
    // 获取黑名单设置
    getBlacklistConfig(params) {
        return request({
            method: 'GET',
            url: '/store/pc/blacklist/staff/getBlacklistConfig',
            params,
        })
    },
    //保存黑名单设置
    setBlacklistConfig(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/setBlacklistConfig',
            data,
        })
    },
    //添加黑名单(手动录入)
    addBlacklistStaff(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/addBlacklistStaff',
            data,
        })
    },
    //解析黑名单Excel
    analysisBlacklistStaffExcel(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/analysisBlacklistStaffExcel',
            data,
        })
    },
    //管理人员列表
    getBlacklistAuditStaffList(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/getBlacklistAuditStaffList',
            data,
        })
    },
    //获取黑名单职员列表
    getBlackStaffList(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/getStaffList',
            data,
        })
    },
    //获取同步门店下拉列表
    getSyncStoreSelectList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/blacklist/staff/getSyncStoreSelectList',
            params,
        })
    },
    //获取未同步已有人员列表
    getUnSyncStaffList(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/getUnSyncStaffList',
            data,
        })
    },
    //移除黑名单
    removeBlackId(params) {
        return request({
            method: 'GET',
            url: '/store/pc/blacklist/staff/removeById',
            params,
        })
    },
    //绑定未同步已有人员
    bindUnSyncStaff(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/bindUnSyncStaff',
            data,
        })
    },
    excelBlacklistStaffList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/excelStaffList',
            data: params,
            responseType: 'blob'
        })
    },
    //导入黑名单人员
    importBlacklistStaff(data) {
        return request({
            method: 'POST',
            url: '/store/pc/blacklist/staff/importBlacklistStaff',
            data,
        })
    },
    // 导出利润排行榜
    excelRankStatistics(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelRankStatistics',
            data: params,
            responseType: 'blob'
        })
    },
    // 导出价格段门店利润排行榜
    excelPriceStoreRankStatistics(params) {
        return request({
            method: 'POST',
            url: '/store/pc/statistics/excelPriceStoreRankStatistics',
            data: params,
            responseType: 'blob'
        })
    },
    unfinishreason(params) {
        return request({
            method: 'GET',
            url: '/store/pc/order/view-unfinish-reason',
            params: params
        })
    },
    //获取公司账户信息2.8.9
    getCompanyAccountInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/account/detail/getCompanyAccountInfo',
            params: params
        })
    },
    //绩效账户调涨2.8.9
    adjustmentAccountPerformance(data) {
        return request({
            method: 'POST',
            url: '/store/pc/account/detail/adjustmentAccount-performance',
            data,
        })
    },
    // 绩效发放管理 - 发放任务分页列表
    getPerformanceTaskPageList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/pageList',
            data: params,
        })
    },
    // 绩效发放管理 - 导出发放任务列表Excel
    exportPerformanceTaskExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/exportExcel',
            data: params,
            responseType: 'blob'
        })
    },
     // 绩效发放管理 - 导出发放明细ExcelExcel
    exportPerformanceexportDetailExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/exportDetailExcel',
            data: params,
            responseType: 'blob'
        })
    },
    // 绩效发放管理 - 创建发放任务
    createPerformanceTask(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/create',
            data: params,
        })
    },
    // 绩效发放管理 - 解析导入发放明细Excel
    parseImportPerformanceExcel(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/parseImportExcel',
            data: params,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    // 绩效发放管理 - 执行发放任务
    runningPerformanceTask(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/running',
            data: params,
        })
    },
    // 绩效发放管理 - 作废发放任务
    invalidPerformanceTask(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/invalid',
            data: params,
        })
    },
    // 绩效发放管理 - 任务执行明细分页
    getPerformanceTaskDetailPageList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/detail/pageList',
            data: params,
        })
    },
    // 绩效发放管理 - 下载企业职员数据
    excelPerformanceStaff() {
        return request({
            method: 'POST',
            url: '/store/pc/performance/task/excelStaff',
            responseType: 'blob'
        })
    },
}
export default menu